import { FC } from "react"

import styles from "./XButton.module.scss"

type XButtonProps = {
  children?: any
  style?: any
  dark?: boolean
  block?: boolean
  primary?: boolean
  danger?: boolean
  disabled?: boolean
  onClick: (ev: any) => void
}

export const XButton: FC<XButtonProps> = ({
  children, style = {}, onClick, block = false, danger = false, dark = false, disabled = false, primary = false
}) => {
  return (
    <>
      <button type="button" disabled={disabled} className={styles.xbutton + (block ? " " + styles.block : "") + (primary ? " " + styles.primary : "") + (dark ? " " + styles.dark : "") + (danger ? " " + styles.danger : "")} style={style} onClick={onClick}>{children}</button>
    </>
  )
}